import { Breakpoint } from "@mui/system";
import React from "react";
import useBelow from "../hooks/useBelow";
import Image from "./Image";
import { GatsbyImageProps } from "gatsby-plugin-image";

export type ResponsiveImageProps = Omit<GatsbyImageProps, "image"> & {
  src: string;
  alt: string;
  srcSmall: string;
  breakpoint: Breakpoint;
};

const ResponsiveImage: React.FC<ResponsiveImageProps> = (props) => {
  const { src, alt, srcSmall, breakpoint, ...rest } = props;
  const belowBreakpoint = useBelow(breakpoint);
  return <Image name={belowBreakpoint ? srcSmall : src} alt={alt} {...rest} />;
};

export default ResponsiveImage;
